import React from 'react';
import { Lightbulb, CheckCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface KeyTakeawaysBoxProps {
  title?: string;
  takeaways: string[];
  variant?: 'default' | 'highlight';
  className?: string;
}

const KeyTakeawaysBox = ({ 
  title = 'Key Takeaways', 
  takeaways, 
  variant = 'default',
  className 
}: KeyTakeawaysBoxProps) => {
  return (
    <div 
      className={cn(
        'rounded-xl p-6 my-8',
        variant === 'default' && 'bg-gradient-to-br from-fordje-blue/5 to-fordje-accent/5 border border-fordje-blue/20',
        variant === 'highlight' && 'bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200',
        className
      )}
    >
      <div className="flex items-center gap-2 mb-4">
        <Lightbulb className={cn(
          'h-5 w-5',
          variant === 'default' && 'text-fordje-blue',
          variant === 'highlight' && 'text-amber-500'
        )} />
        <h4 className="font-semibold text-lg text-fordje-navy">{title}</h4>
      </div>
      <ul className="space-y-3">
        {takeaways.map((takeaway, index) => (
          <li key={index} className="flex items-start gap-3">
            <CheckCircle className={cn(
              'h-5 w-5 mt-0.5 flex-shrink-0',
              variant === 'default' && 'text-fordje-blue',
              variant === 'highlight' && 'text-amber-500'
            )} />
            <span 
              className="text-foreground leading-relaxed"
              dangerouslySetInnerHTML={{ __html: takeaway }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default KeyTakeawaysBox;
